var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pb-0"},[_c('div',{staticClass:"block-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1),_c('v-row',[_c('v-col',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }